import React from 'react';

const DonorsContext = React.createContext({
    donors: [],
    setDonors: () => { }
})

export default DonorsContext;